import ButtonSponsored from '../../buttonSponsored';
import './footerCardTenis.sass';

/**
 * Muestra un botón de momios (apuesta) que redirige a la plataforma del patrocinador para la tarjeta tenis,
 * solo si existe información disponible en `metadata`, con enlace a las apuestas según el patrocinador actual..
 */
export default function FooterCardTenis({ data, patrocinador }) {
  // Se obtiene la metadata específica del patrocinador
  const patrocinadorKey = patrocinador?.toLowerCase() || "";
  const metadata = data[`${patrocinadorKey}_metadata`] || {};

  return (
    <ButtonSponsored url ={metadata.url_mm_evento} buttonClass={"card-tenis__footer-momios"} wrapperClass={"card-tenis__footer"} patrocinador={patrocinador}/>
  )
}